import { debounce } from '../../util/helpers';

export default {
  init() {
    const hero = document.querySelector('.ms-homepage-hero');

    if (hero) {
      this.startListener(hero);
      this.loadVideo(hero);
    }
  },
  startListener(hero) {
    window.addEventListener('load', () => {
      const span = document.createElement('span');
      const lastWord = hero.querySelector('.ms-homepage-hero__last-word');

      span.classList.add('ms-homepage-hero__trailing-line');
      lastWord.appendChild(span);

      const intro = hero.querySelector('.ms-homepage-hero__intro');
      const title = hero.querySelector('.ms-homepage-hero__title');
      const trailingLine = hero.querySelector('.ms-homepage-hero__trailing-line');
      const strong = title.querySelector('strong');
      const castleBG = hero.querySelector('.ms-homepage-hero__castle-bg');

      const titleStyles = getComputedStyle(title);
      const trailingLineStyles = getComputedStyle(trailingLine);

      const handleTrailingLine = (computedWidth) => {
        const br = document.createElement('br');

        if (computedWidth < 75) {

          if (lastWord.querySelector('br') === null) {
            if (strong) {
              strong.insertBefore(br, lastWord);
            } else {
              title.insertBefore(br, lastWord);
            }
          }

          trailingLine.style.width = '235px';
        } else {
          trailingLine.style.width = `${computedWidth}px`;
        }
      }

      const assignTrailingLineWidth = () => {
        const lineCount = title.clientHeight / parseFloat(titleStyles.lineHeight);
        let computedWidth = 0;

        if (title.querySelector('br')) {
          title.querySelector('br').remove();
        }

        if (lineCount > 1) {
          computedWidth = (intro.clientWidth - (lastWord.offsetLeft + lastWord.offsetWidth)) - parseFloat(trailingLineStyles.marginLeft)
          intro.classList.remove('one-line');
        } else {
          computedWidth = (intro.clientWidth - title.clientWidth) - parseFloat(trailingLineStyles.marginLeft);
          intro.classList.add('one-line');
        }

        handleTrailingLine(computedWidth);
      }

      const positionCastleBG = () => {
        const { offsetTop } = intro;
        if (window.innerWidth >= 1280) {
          castleBG.style.top = `${offsetTop - 128}px`;
        } else if (window.innerWidth >= 768) {
          castleBG.style.top = `${offsetTop - 80}px`;
        }
      }

      assignTrailingLineWidth();
      positionCastleBG();

      window.addEventListener('resize', debounce(() => {
        assignTrailingLineWidth();
        positionCastleBG();
      }), 100);
    });
  },
  loadVideo(hero) {
    window.addEventListener('load', () => {
      const videoContainer = hero.querySelector('.video-container');
      if (!videoContainer) return;
      const ytPlayer = videoContainer.querySelector('.yt-player');
      const videoId = ytPlayer.dataset.vidId;
      const playButton = hero.querySelector('.play-button');
      const { dataset: { playHeroVideoText, pauseHeroVideoText } } = playButton;
      const player = window.MSRecipeVideos[videoId];

      playButton.setAttribute('aria-label', playHeroVideoText);
      let isVideoPlaying = false;
      playButton.addEventListener('click', () => {
        if (isVideoPlaying) {
          player.pauseVideo();
          playButton.setAttribute('aria-label', playHeroVideoText);
          playButton.setAttribute('data-playing', false);
        } else {
          player.playVideo();
          playButton.setAttribute('aria-label', pauseHeroVideoText);
          playButton.setAttribute('data-playing', true);
        }
        isVideoPlaying = !isVideoPlaying;
      });
    });
  },
}



// WEBPACK FOOTER //
// /private/var/www/Morton-Windsor/wp-content/themes/morton-salt/resources/assets/scripts/multisite/modules/homepage-hero.js